module.exports = __webpack_public_path__ + "img/delete-red-2.1833ce9e.svg";